/** @format */

import React, { useEffect, useState } from "react";
import { Modal, Button, FormGroup, Input, Label } from "reactstrap";
import { FiX } from "react-icons/fi";

const POSModal = ({
  isOpen,
  toggle,
  products,
  handleSelectPOSProduct,
  selectedProduct,
  setSelectedProduct,
  handleSave,
}) => {
  const [selectedOption, setSelectedOption] = useState("");

  // Sync dropdown value from selected product
  useEffect(() => {
    if (selectedProduct?.shortcut_key) {
      setSelectedOption(selectedProduct.shortcut_key);
    } else {
      setSelectedOption("");
    }
  }, [selectedProduct]);

  const handleShortcutChange = (e) => {
    const key = e.target.value;
    setSelectedOption(key);

    if (!key || !selectedProduct?.id) return;

    const productId = selectedProduct.id.toString();

    // Load and parse stored shortcuts
    const stored = localStorage.getItem("shortcodeActions");
    let parsed = stored ? JSON.parse(stored) : {};

    // Remove existing keys assigned to this product
    for (const shortcut in parsed) {
      if (parsed[shortcut] === productId) {
        delete parsed[shortcut];
      }
    }

    // Assign new shortcut
    parsed[key.replace("+", "")] = productId;
    localStorage.setItem("shortcodeActions", JSON.stringify(parsed));

    // Update selected product state
    setSelectedProduct((prev) => ({
      ...prev,
      shortcut_key: key,
    }));
  };

  const renderShortcutDropdown = () => (
    <FormGroup>
      <Label for="shortcutKeys">Shortcode Keys</Label>
      <Input
        id="shortcutKeys"
        type="select"
        value={selectedOption}
        onChange={handleShortcutChange}
      >
        <option value="">Select Shortcode</option>
        {[...Array(10)].map((_, i) => (
          <option key={i} value={`${i}`}>
            {i}
          </option>
        ))}
        {[...Array(10)].map((_, i) => (
          <option key={i + 10} value={`Shift+${i}`}>
            Shift + {i}
          </option>
        ))}
      </Input>
    </FormGroup>
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className="modal-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          {selectedProduct ? "Edit Product" : "Select Products for POS"}
        </h5>
        <Button className="close-btn" onClick={toggle}>
          <FiX size={20} />
        </Button>
      </div>

      <div className="modal-body">
        {!selectedProduct ? (
          <FormGroup>
            <Input
              type="select"
              onChange={(e) =>
                handleSelectPOSProduct(
                  products.find((p) => p.id == e.target.value) // do not change == to ===
                )
              }
            >
              <option value="">Select Product</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.name} - ${product.regular_price}
                </option>
              ))}
            </Input>
          </FormGroup>
        ) : (
          <>
            <FormGroup>
              <Label>Price</Label>
              <Input
                type="number"
                value={selectedProduct.price}
                onChange={(e) =>
                  setSelectedProduct((prev) => ({
                    ...prev,
                    price: e.target.value,
                  }))
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Quantity</Label>
              <Input
                type="number"
                value={selectedProduct.stock_quantity}
                onChange={(e) =>
                  setSelectedProduct((prev) => ({
                    ...prev,
                    stock_quantity: e.target.value,
                  }))
                }
              />
            </FormGroup>

            <FormGroup className="d-flex align-items-center">
              <Input
                type="checkbox"
                role="switch"
                checked={selectedProduct.taxable}
                onChange={(e) =>
                  setSelectedProduct((prev) => ({
                    ...prev,
                    taxable: e.target.checked,
                  }))
                }
              />
              <Label className="ms-2 mt-2">Taxable</Label>
            </FormGroup>

            {renderShortcutDropdown()}
          </>
        )}
      </div>

      <div className="modal-footer">
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        {selectedProduct && (
          <Button color="primary" onClick={handleSave}>
            Save Changes
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default POSModal;
